import { render, staticRenderFns } from "./HomeIcon.vue?vue&type=template&id=34ac7ecc&scoped=true&"
import script from "./HomeIcon.vue?vue&type=script&lang=js&"
export * from "./HomeIcon.vue?vue&type=script&lang=js&"
import style0 from "./HomeIcon.vue?vue&type=style&index=0&id=34ac7ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac7ecc",
  null
  
)

export default component.exports